import styled from "styled-components";

import { colors, radii } from "shared/ui/tokens";

export const Wrap = styled.div`
    position: relative;
`;

export const Input = styled.input<{ $hasSuffix?: boolean }>`
    width: 100%;
    height: 44px;
    padding: 0 ${({ $hasSuffix }) => ($hasSuffix ? "34px" : "14px")} 0 14px;
    border: 1px solid ${colors.fieldBorder};
    border-radius: ${radii.base};
    background: ${colors.surface};
    font-size: 15px;
    color: ${colors.textPrimary};
    outline: none;

    &:focus {
        border-color: ${colors.primary};
    }

    &::placeholder {
        color: ${colors.textSecondary};
    }

    &:disabled {
        opacity: 0.6;
    }
`;

export const Suffix = styled.span`
    position: absolute;
    right: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: ${colors.textSecondary};
    pointer-events: none;
`;
